/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuDisplayPrefsSelect_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch";
};
export type SbSharedRefineMenuDisplayPrefsSelect_itemSearch$data = SbSharedRefineMenuDisplayPrefsSelect_itemSearch;
export type SbSharedRefineMenuDisplayPrefsSelect_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuDisplayPrefsSelect_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuDisplayPrefsSelect_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'f437fbc882cccc0cac1d3d133e68eb47';
export default node;
